import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var units = {
  KB: 1024,
  MB: 1024 * 1024,
  GB: 1024 * 1024 * 1024
};
export default {
  name: 'UploadImg',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    type: {
      type: String,
      default: 'annexpic'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showTip: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 0
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    sizeUnit: {
      type: String,
      default: 'MB'
    },
    fileSize: {
      default: 5
    }
  },
  data: function data() {
    return {
      fileList: [],
      uploadHeaders: {
        Authorization: this.$store.getters.token
      }
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        this.fileList = val;
      }
    }
  },
  methods: {
    beforeUpload: function beforeUpload(file) {
      var unitNum = units[this.sizeUnit];
      if (!this.fileSize) return true;
      var isRightSize = file.size / unitNum < this.fileSize;
      if (!isRightSize) {
        this.$message.error("\u6587\u4EF6\u5927\u5C0F\u8D85\u8FC7".concat(this.fileSize).concat(this.sizeUnit));
      }
      return isRightSize;
    },
    handleSuccess: function handleSuccess(res, file, fileList) {
      if (res.code == 200) {
        this.fileList.push({
          name: file.name,
          fileId: res.data.name,
          url: res.data.url
        });
        this.$emit('input', this.fileList);
      } else {
        fileList.filter(function (o) {
          return o.uid != file.uid;
        });
        this.$emit('input', this.fileList);
        this.$message({
          message: res.msg,
          type: 'error',
          duration: 1500
        });
      }
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning("\u5F53\u524D\u9650\u5236\u6700\u591A\u53EF\u4EE5\u4E0A\u4F20".concat(this.limit, "\u5F20\u56FE\u7247"));
    },
    handlePictureCardPreview: function handlePictureCardPreview(index) {
      this.$refs['image' + index][0].clickHandler();
    },
    handleRemove: function handleRemove(index) {
      this.fileList.splice(index, 1);
      this.$refs.elUpload.uploadFiles.splice(index, 1);
      this.$emit("input", this.fileList);
    },
    getImgList: function getImgList(list) {
      var _this = this;
      var newList = list.map(function (o) {
        return _this.define.comUrl + o.url;
      });
      return newList;
    }
  }
};